// 5.34.0 "Today" — pure helpers (tested in calendarToday.test.js). All strings are Chicago WALL strings
// ('YYYY-MM-DD' all-day, 'YYYY-MM-DDTHH:MM:SS' timed); `today` is todayWall() — never the PC's own zone.
import { addDays, wallDate } from './calendarTime';

export const TODAY_RED = '#dc2626';
export const CHANGED_EVENT = 'insuredocs-calendar-changed';
export const CHANGED_KEY = 'insuredocs.calendar.changed';

// Does this event (occurrence) cover any part of `today`? All-day ends are exclusive; a timed event ending exactly
// at 00:00 today belongs to yesterday; a zero-length event counts on its own day.
export function coversToday(e, today) {
  if (!e || !e.start) return false;
  const allDay = e.allDay !== undefined ? e.allDay : e.all_day;
  if (allDay) {
    const s = wallDate(e.start);
    const end = e.end ? wallDate(e.end) : addDays(s, 1);
    return s <= today && end > today;
  }
  const dayStart = `${today}T00:00:00`;
  const next = `${addDays(today, 1)}T00:00:00`;
  const end = e.end || e.start;
  return e.start < next && (end > dayStart || (end === e.start && e.start >= dayStart));
}

// Red in the calendar views: today's occurrences of the login's OWN Personal calendar only.
export function isTodayRed(e, myPersonalId, today) {
  return !!myPersonalId && e.calendar_id === myPersonalId && coversToday(e, today);
}

const fmtTime = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', hour: 'numeric', minute: '2-digit' });
const fmtDayTime = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'short', hour: 'numeric', minute: '2-digit' });
const t = (s) => fmtTime.format(new Date(`${s}Z`));

// The time line of a panel row.
export function itemWhen(i, today) {
  if (i.kind === 'task') return i.due_all_day || !i.due || i.due.length <= 10 ? 'Due today' : `Due ${t(i.due)}`;
  if (i.all_day) {
    const last = i.end ? addDays(wallDate(i.end), -1) : wallDate(i.start);
    return last > wallDate(i.start) ? 'All day (several days)' : 'All day';
  }
  const startsToday = wallDate(i.start) === today;
  const endsToday = wallDate(i.end || i.start) === today;
  if (startsToday && endsToday) return i.end && i.end !== i.start ? `${t(i.start)} – ${t(i.end)}` : t(i.start);
  if (startsToday) return `${t(i.start)} – ${fmtDayTime.format(new Date(`${i.end}Z`))}`;
  if (endsToday) return `Until ${t(i.end)}`;
  return 'All day (continues)';
}

// Tell every InsureDocs window that a calendar item changed (the Today panel refreshes at once).
export function notifyCalendarChanged() {
  try { window.dispatchEvent(new Event(CHANGED_EVENT)); } catch (_e) { /* ignore */ }
  try { localStorage.setItem(CHANGED_KEY, String(Date.now())); } catch (_e) { /* ignore */ }
}

// Calendar tab address for a panel click.
export const eventUrl = (day, objectId) => `/?calendar=1&day=${encodeURIComponent(day)}&event=${encodeURIComponent(objectId)}`;
export const tasksUrl = () => '/?calendar=1&tab=tasks';
